export const LIBRARIES_FETCH_REQUESTED = 'LIBRARIES_FETCH_REQUESTED' as const;
export const LIBRARIES_FETCH_SUCCEEDED = 'LIBRARIES_FETCH_SUCCEEDED' as const;
export const LIBRARIES_FETCH_FAILED = 'LIBRARIES_FETCH_FAILED' as const;
export const LIBRARY_INSTALLATIONS_FETCH_REQUESTED =
  'LIBRARY_INSTALLATIONS_FETCH_REQUESTED' as const;
export const LIBRARY_INSTALLATIONS_FETCH_SUCCEEDED =
  'LIBRARY_INSTALLATIONS_FETCH_SUCCEEDED' as const;
export const LIBRARY_INSTALLATIONS_FETCH_FAILED =
  'LIBRARY_INSTALLATIONS_FETCH_FAILED' as const;

export const LIBRARY_ASSET_SETTINGS_UPDATED =
  'LIBRARY_ASSET_SETTINGS_UPDATED' as const;

export const RECOVER_ORPHANED_LIBRARY_CONTENT_MODAL_OPENED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_MODAL_OPENED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_MODAL_CLOSED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_MODAL_CLOSED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_BOOTSTRAPPED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_BOOTSTRAPPED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_DATA_UPDATED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_DATA_UPDATED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_STARTED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_STARTED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_FINISHED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_FINISHED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_FAILED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENGINE_FAILED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENQUEUE_STARTED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENQUEUE_STARTED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_ENQUEUE_SUCCEEDED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_ENQUEUE_SUCCEEDED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_JOB_FAILED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_JOB_FAILED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_JOB_SUCCEEDED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_JOB_SUCCEEDED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_RELOAD_STARTED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_RELOAD_STARTED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_RELOAD_FAILED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_RELOAD_FAILED' as const;
export const RECOVER_ORPHANED_LIBRARY_CONTENT_RELOAD_FINISHED =
  'RECOVER_ORPHANED_LIBRARY_CONTENT_RELOAD_FINISHED' as const;

export const LIBRARY_ASSET_ENGINE_STARTED =
  'LIBRARY_ASSET_ENGINE_STARTED' as const;
export const LIBRARY_ASSET_ENGINE_RUNNING =
  'LIBRARY_ASSET_ENGINE_RUNNING' as const;
export const LIBRARY_ASSET_ENGINE_FAILED =
  'LIBRARY_ASSET_ENGINE_FAILED' as const;
export const LIBRARY_ASSET_ENGINE_FINISHED =
  'LIBRARY_ASSET_ENGINE_FINISHED' as const;

export const MANAGE_LIBRARY_INSTALL_STARTED =
  'MANAGE_LIBRARY_INSTALL_STARTED' as const;
export const MANAGE_LIBRARY_INSTALL_QUEUED =
  'MANAGE_LIBRARY_INSTALL_QUEUED' as const;
export const MANAGE_LIBRARY_INSTALL_FAILED =
  'MANAGE_LIBRARY_INSTALL_FAILED' as const;
export const MANAGE_LIBRARY_INSTALL_SUCCEEDED =
  'MANAGE_LIBRARY_INSTALL_SUCCEEDED' as const;

export const LIBRARY_TO_INSTALL_AFTER_DISABLE_CLONING_SET =
  'LIBRARY_TO_INSTALL_AFTER_DISABLE_CLONING_SET' as const;
export const MANAGE_LIBRARY_UNINSTALL_STARTED =
  'MANAGE_LIBRARY_UNINSTALL_STARTED' as const;
export const MANAGE_LIBRARY_UNINSTALL_QUEUED =
  'MANAGE_LIBRARY_UNINSTALL_QUEUED' as const;
export const MANAGE_LIBRARY_UNINSTALL_FAILED =
  'MANAGE_LIBRARY_UNINSTALL_FAILED' as const;
export const MANAGE_LIBRARY_UNINSTALL_SUCCEEDED =
  'MANAGE_LIBRARY_UNINSTALL_SUCCEEDED' as const;

export const PUBLISH_SITE_LIBRARY_REQUESTED =
  'PUBLISH_SITE_LIBRARY_REQUESTED' as const;
export const UNPUBLISH_SITE_LIBRARY_STARTED =
  'UNPUBLISH_SITE_LIBRARY_STARTED' as const;
export const UNPUBLISH_SITE_LIBRARY_SUCCEEDED =
  'UNPUBLISH_SITE_LIBRARY_SUCCEEDED' as const;
export const UNPUBLISH_SITE_LIBRARY_FAILED =
  'UNPUBLISH_SITE_LIBRARY_FAILED' as const;

export const PUSH_LIBRARY_UPDATES_REQUESTED =
  'PUSH_LIBRARY_UPDATES_REQUESTED' as const;
export const PUSH_LIBRARY_UPDATES_SUCCEEDED =
  'PUSH_LIBRARY_UPDATES_SUCCEEDED' as const;
export const PUSH_LIBRARY_UPDATES_FAILED =
  'PUSH_LIBRARY_UPDATES_FAILED' as const;

export const LIBRARY_CHANGELOG_STARTED = 'LIBRARY_CHANGELOG_STARTED' as const;
export const LIBRARY_CHANGELOG_FINISHED = 'LIBRARY_CHANGELOG_FINISHED' as const;
export const LIBRARY_CHANGELOG_FAILED = 'LIBRARY_CHANGELOG_FAILED' as const;
export const LIBRARY_CHANGELOG_RESET = 'LIBRARY_CHANGELOG_RESET' as const;

export const LIBRARY_MODAL_OPENED = 'LIBRARY_MODAL_OPENED' as const;
export const LIBRARY_MODAL_CLOSED = 'LIBRARY_MODAL_CLOSED' as const;

export const DYNAMIC_INSTALL_READY = 'DYNAMIC_INSTALL_READY' as const;
export const DYNAMIC_INSTALL_FINISHED = 'DYNAMIC_INSTALL_FINISHED' as const;
export const LIBRARY_ASSET_IMPORT_SUCCEEDED =
  'LIBRARY_ASSET_IMPORT_SUCCEEDED' as const;
export const DYNAMIC_INSTALL_FAILED = 'DYNAMIC_INSTALL_FAILED' as const;
export const DYNAMIC_UNINSTALL_REQUESTED =
  'DYNAMIC_UNINSTALL_REQUESTED' as const;
export const DYNAMIC_UNINSTALL_STARTED = 'DYNAMIC_UNINSTALL_STARTED' as const;
export const DYNAMIC_UNINSTALL_FAILED = 'DYNAMIC_UNINSTALL_FAILED' as const;
export const DYNAMIC_PLUGINS_READY = 'DYNAMIC_PLUGINS_READY' as const;
export const DYNAMIC_PLUGINS_RELOAD_STARTED =
  'DYNAMIC_PLUGINS_RELOAD_STARTED' as const;
export const DYNAMIC_PLUGINS_RELOAD_FINISHED =
  'DYNAMIC_PLUGINS_RELOAD_FINISHED' as const;
export const DYNAMIC_PLUGINS_RELOAD_FAILED =
  'DYNAMIC_PLUGINS_RELOAD_FAILED' as const;
export const DETACH_LIBRARY_COMPONENT_INSTANCE =
  'DETACH_LIBRARY_COMPONENT_INSTANCE' as const;
export const UNLINK_LIBRARY_COMPONENT_INSTANCE =
  'UNLINK_LIBRARY_COMPONENT_INSTANCE' as const;

export const INSTALLED_RESOURCES_LOADED = 'INSTALLED_RESOURCES_LOADED' as const;
export const LIBRARY_ASSET_DUPLICATED = 'LIBRARY_ASSET_DUPLICATED' as const;

export const LIBRARIES_UPDATES_AVAILABLE =
  'LIBRARIES_UPDATES_AVAILABLE' as const;

export const LIBRARY_PUSH_UPDATES_AVAILABLE =
  'LIBRARY_PUSH_UPDATES_AVAILABLE' as const;

export const LIBRARY_TAG_STYLES_SETTINGS_CHANGE_REQUESTED =
  'LIBRARY_TAG_STYLES_SETTINGS_CHANGE_REQUESTED' as const;
export const LIBRARY_TAG_STYLES_SETTINGS_CHANGE_SUCCEEDED =
  'LIBRARY_TAG_STYLES_SETTINGS_CHANGE_SUCCEEDED' as const;
export const LIBRARY_TAG_STYLES_SETTINGS_CHANGE_FAILED =
  'LIBRARY_TAG_STYLES_SETTINGS_CHANGE_FAILED' as const;

export const INSTALLED_LIBRARIES_TAG_STYLES_SETTINGS_UPDATED =
  'INSTALLED_LIBRARIES_TAG_STYLES_SETTINGS_UPDATED' as const;

export const LIBRARY_COMPONENT_CREATED = 'LIBRARY_COMPONENT_CREATED' as const;
